import type { PageTheme } from '@backstage/theme';
import { karcher } from './palettes';

const HEADER_SURFACE = karcher.neutral[900];
const RULE_HEIGHT = 4;

/**
 * Kärcher encodes a business line as a coloured rule under the navigation bar
 * (`#main-nav.fc-hg` yellow for Home & Garden, `.fc-pro` grey for
 * Professional). Reusing that idiom keeps Backstage's per-page identity
 * without the default gradients, which have no counterpart in the CI.
 *
 * `Header` applies `background-size: cover`. Gradients have no intrinsic size,
 * so they resolve to exactly the header box and the 4px stop stays 4px.
 */
const brandRule = (rule: string): PageTheme => ({
  colors: [HEADER_SURFACE],
  shape: 'none',
  backgroundImage: [
    `linear-gradient(to top, ${rule} ${RULE_HEIGHT}px, transparent ${RULE_HEIGHT}px)`,
    `linear-gradient(${HEADER_SURFACE}, ${HEADER_SURFACE})`,
  ].join(', '),
  fontColor: karcher.neutral[0],
});

export const karcherPageThemes: Record<string, PageTheme> = {
  home: brandRule(karcher.yellow),
  documentation: brandRule(karcher.yellow),
  card: brandRule(karcher.yellow),
  service: brandRule(karcher.petrol[700]),
  apis: brandRule(karcher.petrol[700]),
  tool: brandRule(karcher.petrol[700]),
  app: brandRule(karcher.petrol[700]),
  website: brandRule(karcher.petrol[500]),
  library: brandRule(karcher.petrol[500]),
  other: brandRule(karcher.neutral[600]),
};
